/**
 * @file       Lazy-loaded routes under SecureLayout (AuthGuard).
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@app/secure/helper/auth.guard';
import { SecureLayoutComponent } from
    '@app/secure/core/layout/secureLayout.component';

const secureRoutes: Routes =
[{
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
},
{
    path: '',
    component: SecureLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
        {
            path: 'dashboard',
            loadComponent: () =>
                import('@app/secure/dashboard/dashboard.component')
                .then(m => m.DashboardComponent)
        },
        { path: 'settings',
            loadChildren: () =>
              import('@app/secure/setting/setting.module')
              .then(m => m.SettingModule)
        },
        { path: 'case',
            loadChildren: () =>
              import('@app/secure/case/case.module')
              .then(m => m.CaseModule)
        },
        {
            path: 'caseMotion/detail',
            loadComponent: () =>
              import('@app/secure/caseMotion/caseMotion/caseMotion.component')
              .then(m => m.CaseMotionDetailComponent)
        },
        { path: 'probations',
            loadComponent: () =>
              import('@app/secure/probation/probations/probations.component')
              .then(m => m.ProbationsComponent)
        },
        {
            path: 'probation',
            loadComponent: () =>
              import('@app/secure/probation/probation/probation.component')
              .then(m => m.ProbationComponent)
        },
        {
            path: 'caseActions',
            loadComponent: () =>
              import('@app/secure/caseAction/caseActions/caseActions.component')
              .then(m => m.CaseActionsComponent)
        },
        {
            path: 'dockets',
            loadComponent: () =>
              import('@app/secure/docket/dockets.component')
              .then(m => m.DocketsComponent)
        },
        {
            path: 'dockets/generateDockets',
            loadComponent: () =>
              import('@app/secure/docket/docketTemplate/docketTemplate.component')
              .then(m => m.DocketTemplateComponent)
        },
        {
            path: 'courtCalendar',
            loadComponent: () =>
              import('@app/secure/courtCalendar/courtCalendar.component')
              .then(m => m.CourtCalendarComponent)
        },
        {
            path: 'prosecutorCalendar',
            loadComponent: () =>
              import('@app/secure/prosecutorCalendar/prosecutorCalendar.component')
              .then(m => m.ProsecutorCalendarComponent)
        },
        {
            path: 'courtSchedule',
            loadComponent: () =>
              import('@app/secure/courtSchedule/courtSchedule.component')
              .then(m => m.CourtScheduleComponent)
        },
        { path: 'citations',
          loadChildren: () =>
              import('@app/secure/citations/citations.module')
              .then(m => m.CitationsModule)
        },
        { path: 'citation',
          loadChildren: () =>
              import('@app/secure/citation/citation.module')
              .then(m => m.CitationModule)
        },
        { path: 'notifications',
           loadChildren: () =>
               import('@app/secure/messages/messages.module')
               .then(m => m.MessagesModule)
        },
        { path: 'message',
           loadChildren: () =>
               import('@app/secure/message/message.module')
               .then(m => m.MessageModule)
        },
        { path: 'tickets',
            loadChildren: () =>
                import('@app/secure/tickets/tickets.module')
                .then(m => m.TicketsModule)
        },
        { path: 'ticket',
            loadChildren: () =>
                import('@app/secure/ticket/ticket.module')
                .then(m => m.TicketModule)
        },
        { path: 'compliance',
            loadChildren: () =>
                import('@app/secure/compliance/compliance.module')
                .then(m => m.ComplianceModule)
        },
        { path: 'analytic',
            loadChildren: () =>
                import('@app/secure/analytic/analytic.module')
                .then(m => m.AnalyticModule)
        },
        { path: 'inspectionsCalendar',
            loadChildren: () =>
              import('@app/secure/inspectionsCalendar/' +
                     'inspectionsCalendar.module')
              .then(m => m.InspectionsCalendarModule)
        },
        { path: 'inspections',
            loadChildren: () =>
              import('@app/secure/inspections/inspections.module')
              .then(m => m.InspectionsModule)
        },
        { path: 'inspection',
            loadChildren: () =>
              import('@app/secure/inspection/inspection.module')
              .then(m => m.InspectionModule)
        },
        { path: 'businesses',
            loadChildren: () =>
              import('@app/secure/businesses/businesses.module')
              .then(m => m.BusinessesModule)
        },
        { path: 'business',
            loadChildren: () =>
              import('@app/secure/business/business.module')
              .then(m => m.BusinessModule)
        },
        // letterTemplate admin: list and edit (Court Management)
        {
            path: 'formTemplates',
            loadComponent: () =>
                import('@app/secure/formTemplates/formTemplatesList.component')
                .then(m => m.FormTemplatesListComponent)
        },
        {
            path: 'formTemplate/edit/:id',
            loadComponent: () =>
                import('@app/secure/formTemplates/formTemplateEdit.component')
                .then(m => m.FormTemplateEditComponent)
        },
        {
            path: 'caseQueue',
            loadComponent: () =>
                import('@app/secure/caseQueue/caseQueue.component')
                .then(m => m.CaseQueueComponent)
        },
        {
            path: 'editCaseQueue',
            loadComponent: () =>
                import('@app/secure/caseQueue/editCaseQueue.component')
                .then(m => m.EditCaseQueueComponent)
        },
        {
            path: 'juryModule',
            loadComponent: () =>
                import('@app/secure/jury/juryModule.component')
                .then(m => m.JuryModuleComponent)
        },
        {
            path: 'juryCaseHearing',
            loadComponent: () =>
                import('@app/secure/jury/trials/juryCaseHearing.component')
                .then(m => m.JuryCaseHearingComponent)
        },
        {
            path: 'trialAttendance',
            loadComponent: () =>
                import('@app/secure/jury/trials/trialAttendance.component')
                .then(m => m.TrialAttendanceComponent)
        },
        {
            path: 'demo',
            loadComponent: () =>
                import('@app/demo/demo.component')
                .then(m => m.DemoComponent)
        }
//      { path: 'account-settings',
//        loadChildren:
//          '../account-settings/account-settings.module#AccountSettingsModule' }
    ]
}];

@NgModule({
    imports: [RouterModule.forChild(secureRoutes)],
    exports: [RouterModule]
})
export class SecureRoutingModule { }
